import { PdPanelViewer } from "./pd-panel-viewer/PdPanelViewer.js";
//#region src/pd-panel-viewer/pd-panel-viewer.ts
var tag = "pd-panel-viewer";
if (!customElements.get(tag)) customElements.define(tag, PdPanelViewer);
//#endregion
export { PdPanelViewer };
